import { useStores } from 'hooks';
import { observer } from 'mobx-react-lite';
import React from 'react';
import { Checkbox } from '../Controls/Checkbox';
import { FilterWrapper } from '../Styles';

export const FilterCheckboxes = observer(({ controls = [], group }) => {
  const {
    DebuggerStore: { getFilter, updateFilter2 },
  } = useStores();

  return (
    <FilterWrapper>
      {controls?.map(({ text, value }) => (
        <Checkbox
          key={`filter_chk_${group}_${value}`}
          checkedValue={getFilter(group)}
          //style={style}
          group={group}
          onClick={(value) => updateFilter2(group, value)}
          text={text}
          value={value}
          labelStyle={{
            color: getFilter(group) === value ? 'green' : '#eee',
          }}
        />
      ))}
    </FilterWrapper>
  );
});

export default FilterCheckboxes;
